import { useState } from "react";
import { environment } from "../environment";
import { useAxios } from "./useAxios";

export const useOnboarding = () => {

  const { axiosInstance, kcToken } = useAxios()

  const [accountHolder, setAccountHolder] = useState({
    radioGender: "",
    radioPep: "",
    firstName: "",
    lastName: "",
    birthday: new Date(),
    selectedCountry: null,
  });

  const [identityDoc, setIdendtityDoc] = useState({
    identityDocument: "",
    idDocValid: new Date(),
  });

  const [pageFour, setPageFour] = useState({
    selfie: "",
  });

  const [companyData, setCompanyData] = useState({
    companyName: "",
    companyVat: "",
    dateOfCompanyEstablished: new Date(),
    companyAddress: "",
    companyStreetNumber: "",
    companyCity: "",
    companyPostalCode: "",
    companyCountry: null,
  });

  const [selectedActivies, setSelectedActivities] = useState([]);
  const [selectedSubActivities, setSelectedSubActivities] = useState([]);

  const [pageSeven, setPageSeven] = useState({
    doc: "",
  });

  const [pageEight, setPageEight] = useState({
    array: [],
  });

  const [pageNine, setPageNine] = useState({
    doc: "",
    checked: false,
    array: [],
  });


  const url = environment.apiServerUrl + environment.CreateAccount;

  const AccountCreate = () => {
    axiosInstance?.current?.post(url, { accountHolder }).then((res) => {
      const response = res
      console.log(response)
    })
  }


  /* public createAccount(data: AccountCreateData): Observable<BasicResponse<AccountData>> {
    return this.http.post<BasicResponse<AccountData>>(this.api_url + '/smarpay/api/v1/accounts/public/create', data, {headers: this.headers}).pipe(
      tap((response: BasicResponse<AccountData>) => console.log(`Account create`)),
      catchError(ErrorHandlingService.handleError<any>(this.router))
    );
  } */



  return {
    accountHolder,
    setAccountHolder,
    identityDoc,
    setIdendtityDoc,
    pageFour,
    setPageFour,
    companyData,
    setCompanyData,
    selectedActivies,
    setSelectedActivities,
    selectedSubActivities,
    setSelectedSubActivities,
    pageSeven,
    setPageSeven,
    pageEight,
    setPageEight,
    pageNine,
    setPageNine,
    AccountCreate
  };
};
